export const TEST_IDS = {
  list: 'list',
  listHeader: 'list-header',
  issueRowItem: (postFix: string | number) => `issue-row-${postFix}`,
  pullRequestRowItem: (postFix: string | number) => `pull-request-row-${postFix}`,
  searchInput: 'search-input',
  searchWithFilterInput: 'filter-input',
  headerLoading: 'header-loading',
  listRowComments: 'list-row-comments',
  listRowAssignees: 'list-row-assignees',
  listRowLabels: 'list-row-labels',
  listRowStateIcon: 'list-row-state-icon',
  listRowRepoNameAndNumber: 'list-row-repo-name-and-number',
  listTitle: 'list-title',
  issueViewerContainer: 'issue-viewer-container',
  listRowLinkedPullRequests: 'list-row-linked-pull-requests',
  fallback: 'list-error-fallback',
  milestoneAnchorFilter: 'milestones-anchor-button',
  issueTypeAnchorFilter: 'issue-types-anchor-button',
  ftcBannerContributingGuidelinesLink: 'contributing-guidelines',
}
